import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
//utils
import { Translations, convertStringToArray } from '../../../utils';
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
//import {setCurrentActiveTab, enableTab} from './actions/actionCreator';
//rest client
import { aemHostClient } from '../../../restClient';
// children
import Panel from '../../common/Tabs/Panel';
import Tabs from '../../common/Tabs/Tabs';
import BasicDetails from './SubComp/BasicDetails';
import CaseHistory from './SubComp/CaseHistory';
import Documentation from './SubComp/Documentation';
import ProductRequests from './SubComp/ProductRequests';

//action creator
import { activeTab, disableTabs, newManualCase, redirectToTab } from '../actions/actionCreator';
//style
import './CaseBody.css';

class AddCase extends Component {

  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      enableProductList: false,
      enableCaseHistory: false,
      enableDocumentation: false,
      selectedActiveTab: 0,
      msaCases: false
    };
    this.locationState = props.history.location.state;
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  disableActiveTabs = () => {
    this.props.disableTabs();
  }

  setCurrentActiveTab = (index) => {
    this.props.redirectToTab(index);
  }

  setTabEnabled = (index) => {
    this.props.activeTab(index);
  }

  componentWillMount() {
    if (Object.keys(this.props.case).length === 0 && this.props.case.constructor === Object) {
      this.props.activeTab(0);
      this.props.redirectToTab(0);
      this.props.disableTabs();
      this.locationState !== undefined && this.locationState.case !== undefined ? this.props.newManualCase(this.locationState.case) : '';
    }


    aemHostClient("/aemData/formData/json_manual-case-basic-detail-page")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
      });

    aemHostClient("/aemData/formData/json_manual-case-product-requests-page")
      .then(({ data }) => {
        this.setState({ productListPageJson: data.par })
      });

    aemHostClient("/aemData/formData/json_manual-case-documentation-page")
      .then(({ data }) => {
        this.setState({ documentationPageJson: data.par })
      });

    aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({ data }) => {
        this.setState({ darkTitleBarJson: data.par });
        document.title = `${Translations(data.par.static_text_darkTitleBar.manualCaseRecord, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
        this.props.setDarkTitleBarContent(Translations(data.par.static_text_darkTitleBar.manualCaseRecord, this.props.lang.currentLang.lang, this.props.lang.translatedData));
      });
  }


  render() {
    let caseBodyJsx;
    if (this.state.pageJson === undefined || this.state.productListPageJson === undefined) {
      caseBodyJsx = (<h3>Loading...</h3>);
    } else {
      caseBodyJsx = (
        <div id="manualrecord" className="gdoc-manualrecord-container">
          <Tabs
            selected={this.props.tabSelected.activeTabId}
            ariaSelected={this.props.tabSelected.activeTabId}
            useReduxHandler={true}
            setCurrentActiveTab={this.setCurrentActiveTab}
          >
            <Panel
              label={this.translateWord(this.state.pageJson.tab_pageTab.text)[0]}
              disabled={false}
            >
              <BasicDetails
                history={this.props.history}
                formJson={this.state.pageJson}
                setTabActive={this.setCurrentActiveTab}
                setTabEnabled={this.setTabEnabled}
                disableActiveTabs={this.disableActiveTabs}
                BasicDetailsData={this.state.formData}
                msaCases={this.state.msaCases}
                handleMsaCases={(value) => { this.setState({ msaCases: value }) }}
                // Check line 437, 438 of src/components/CaseList/CaseList.js - where this value is set
                // Alternatively, isTnC flag can be a part of respective API calls in each tab component
                isTnC={(this.locationState && this.locationState.case && this.locationState.case.isTnC) || false}
              />
            </Panel>
            <Panel label={this.translateWord(this.state.pageJson.tab_pageTab.text)[1]}
              disabled={!this.props.tabSelected.tabEnabled}
            >
              <ProductRequests
                pageJson={this.state.productListPageJson}
                history={this.props.history}
                setTabActive={this.setCurrentActiveTab}
                isTnC={(this.locationState && this.locationState.case && this.locationState.case.isTnC) || false}
              />
            </Panel>
            <Panel label={this.translateWord(this.state.pageJson.tab_pageTab.text)[2]}
              disabled={!this.props.tabSelected.tabEnabled&&!this.props.tabSelected.activeTabEnabled}
            >
              <Documentation
                pageJson={this.state.documentationPageJson}
                history={this.props.history}
                setTabActive={this.setCurrentActiveTab}
                msaCases={this.state.msaCases}
                isTnC={(this.locationState && this.locationState.case && this.locationState.case.isTnC) || false}
              />
            </Panel>
            <Panel label={this.translateWord(this.state.pageJson.tab_pageTab.text)[3]}
              disabled={!this.props.tabSelected.tabEnabled}
            >
              <CaseHistory
                history={this.props.history}
                mode="manual-case"
              />
            </Panel>
          </Tabs>
        </div>
      );
    }
    return (<div>{caseBodyJsx}</div>)
  }
}

AddCase.propTypes = {
  userData: PropTypes.array,
  glsApprovals: PropTypes.array,
};

const mapStateToProps = state => ({
  lang: state.lang,
  tabSelected: state.activeTab,
  case: state.newManualCase,
  activeTabId: state.activeTab.activeTabId
})

const mapDispatchToProps = dispatch => {
  return {
    activeTab: index => {
      dispatch(activeTab(index))
    },
    redirectToTab: index => {
      dispatch(redirectToTab(index))
    },
    disableTabs: () => dispatch(disableTabs()),
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    newManualCase: newCase => {
      dispatch(newManualCase(newCase))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCase);



// WEBPACK FOOTER //
// ./src/components/Admin/CaseBody/index.js